import { useTranslation } from "react-i18next";
import { AudienceEditor } from "@/partner/features/audience";
import { Broadcasts } from "@/partner/features/broadcasts";
import {
  EmailTemplateAutocomplete,
  EmailTemplatePreviewById,
} from "@/partner/features/emailTemplates";
import {
  MarketingComponentsProvider,
  type MarketingComponents,
} from "@/partner/entities/marketing";
import { ProductLabelsProvider } from "@/partner/entities/products";
import { Meta } from "@/shared/components";

// Страница собирает куски других фич для рассылок (фичи друг друга не импортируют).
const MARKETING_COMPONENTS: MarketingComponents = {
  AudienceEditor,
  EmailTemplatePicker: EmailTemplateAutocomplete,
  EmailTemplatePreview: EmailTemplatePreviewById,
};

export function BroadcastsPage() {
  const { t } = useTranslation();

  return (
    <MarketingComponentsProvider value={MARKETING_COMPONENTS}>
      <Meta title={t("broadcasts.pageTitle")} pageType="Partner" />
      {/* Названия выбранных продуктов во всех условиях редактора одним
          запросом (супер-ревью кабинета 9). */}
      <ProductLabelsProvider>
        <Broadcasts />
      </ProductLabelsProvider>
    </MarketingComponentsProvider>
  );
}
